import { EnvironmentTag } from '@dmp/shared/components/environment-tag';
import 'focus-visible/dist/focus-visible';
import ReactDOM from 'react-dom/client';
import App from './app/app';
import { AppProvider } from './app/app-provider';
import { Changelog } from './app/components/common/changelog';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <AppProvider>
        <App />
        <EnvironmentTag />
        <Changelog />
    </AppProvider>
);
